Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PinterestFollowButton = void 0;

var _react = _interopRequireDefault(require("react"));

var _generalObserver = require("../general-observer");

var _utils = require("./utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var PinterestFollowButton = function PinterestFollowButton(_ref) {
  var username = _ref.username;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, {
    onEnter: function onEnter() {
      return (0, _utils.handlePinterestBuild)();
    }
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: "pinterest-follow-button pinterest-follow-button-mdx-embed",
    "data-testid": "pinterest-follow-button",
    "data-pin-do": "buttonFollow",
    href: "https://www.pinterest.com/".concat(username, "/")
  }, "Follow @".concat(username)));
};

exports.PinterestFollowButton = PinterestFollowButton;